<!--
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2022-02-17 11:20:49
 * @LastEditTime: 2022-02-28 14:09:20
 * @Description: file content
-->
<template >
  <div id="permission-menu-tree" class="h100">
    <div class="h-12 bg-F5 border border-solid border-C6 flex justify-between">
      <div class="pl-5 mt-1 leading-10 scim-text-color fn14">菜单树</div>
      <div class="pr-5 mt-1 leading-10 ext-gray-901 fn12">
        <span class="cursor-pointer hover:text-primary" @click="expandTree(true)">全部展开</span>
        <span class="pr-2 pl-2">|</span>
        <span class="cursor-pointer hover:text-primary" @click="expandTree(false)">全部收起</span>
      </div>
    </div>
    <div class="tree">
      <el-tree
        ref="centerTree"
        class="self-tree data_tree"
        :data="treeData"
        show-checkbox
        node-key="id"
        :check-strictly="!strictly"
        :highlight-current="false"
        :props="defaultProps"
        v-bind="$attrs"
        @check-change="checkChange"
      >
        <span slot-scope="{ node }">
          <svg-icon v-if="node.data.icon !== undefined" :icon-class="node.data.icon" class="mr-1"></svg-icon>
          <span class="">{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: "PermissionMenuTree",
  props: {
    strictly: {
      type: Boolean,
      default: () => false
    },

    treeData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },

  methods: {
    /**
     * @description:展开收起菜单树
     * @param {*} expand
     * @return {*}
     */
    expandTree(expand) {
      const { nodesMap } = this.$refs.centerTree.store;
      for (const key in nodesMap) {
        // 全部关闭
        if (key === "-2") {
          nodesMap[key].expanded = true;
        } else {
          nodesMap[key].expanded = expand;
        }
      }
    },

    /**
     * @description:
     * @param {*} data
     * @return {*}
     */
    nodeIcon(data) {},

    /**
     * @description:
     * @param {*} node
     * @param {*} isCheck
     * @return {*}
     */
    checkChange(node, isCheck) {
      // 非父子联动情况
      if (!this.strictly) {
        // 选中则设置父为选中
        isCheck && this.collectionParentKeys(node, this.treeData).forEach(key => this.$refs.centerTree.setChecked(key, true));
        // // 取消选中则设置子为未选中
        !isCheck && this.collectionChildrenKeys(node.children).forEach(key => this.$refs.centerTree.setChecked(key, false));
      }
      this.hasChangeCheck = true;
    },
    // 获取选中节点
    getCheckedKeys() {
      const array = this.$refs.centerTree.getCheckedKeys();
      // this.$refs.centerTree.getCheckedKeys().forEach(element => {
      //   if (element !== 'xxxxxxxxxxxxxxx') {
      //     array.push(element);
      //   }
      // });
      return array;
    },
    getHalfCheckedKeys() {
      const array = this.$refs.centerTree.getHalfCheckedKeys();
      // this.$refs.centerTree.getHalfCheckedKeys().forEach(element => {
      //   if (element !== 'xxxxxxxxxxxxxxx') {
      //     array.push(element);
      //   }
      // });
      return array;
    },
    // 获取选中节点
    getCheckedNodes() {
      const array = this.$refs.centerTree.getCheckedNodes();
      // this.$refs.centerTree.getCheckedNodes().forEach(element => {
      //   if (element.id !== 'xxxxxxxxxxxxxxx') {
      //     array.push(element);
      //   }
      // });
      return array;
    },
    getHalfCheckedNodes() {
      const array = this.$refs.centerTree.getHalfCheckedNodes();
      // this.$refs.centerTree.getHalfCheckedNodes().forEach(element => {
      //   if (element.id !== 'xxxxxxxxxxxxxxx') {
      //     array.push(element);
      //   }
      // });
      return array;
    },
    filter(value) {
      this.$refs.centerTree.filter(value);
    },
    // 收集父级keys
    collectionParentKeys(node, data, keys = []) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        // 找到直接return
        if (item.id === node.id) {
          return keys;
        }
        keys.push(item.id);

        if (Array.isArray(item.children)) {
          const findKeys = this.collectionParentKeys(node, item.children, keys);

          // 找到keys
          if (findKeys.length) {
            return findKeys;
          }
        }

        // 均未找到
        keys.pop();
      }

      return [];
    },
    // 收集子级keys
    collectionChildrenKeys(nodes, keys = []) {
      if (Array.isArray(nodes)) {
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          keys.push(node.id);

          if (Array.isArray(node.children)) {
            this.collectionChildrenKeys(node.children, keys);
          }
        }
      }
      return keys;
    }
  }
};
</script>

<style lang="scss" scoped>
#permission-menu-tree {
  ::v-deep .el-tree .el-tree-node__content {
    position: relative;
    width: 100%;
    min-width: 420px;
    line-height: 48px;
    height: 48px !important;
    border-bottom: 1px solid #c6ccd7;
    border-top: none;
  }

  .tree {
    height: calc(100% - 48px);
    overflow: overlay;
    border: 1px solid #c6ccd7;
  }
}
</style>
